<template>
  <div></div>
</template>

<script>
export default {
  name: "EdIcons"
}
</script>

<style scoped>

</style>
